import styled from "styled-components";

const StakingStyleWrapper = styled.div`
  background: #090a1a;
  padding: 80px 0 50px 0;
`;

export default StakingStyleWrapper;
